import React from "react";
import { useNavigate } from "react-router-dom";
import "./BlogCard.css";


const colors = {
  mainBlue: "#061941",
  cafeNoir: "#583E23",
  carrieban: "#3C6E71",
  xanthous: "#F2AF29",
};

const BlogCard = ({ article }) => {
  const navigate = useNavigate();

  if (!article) {
    console.error("BlogCard received undefined article");
    return null;
  }
  
  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  const handleClick = () => {
    const slug = createSlug(article.title);
    navigate(`/Blogs/${slug}`);
  };

  return (
    <div className="blog-card" onClick={handleClick}>
      <div className="blog-card-image">
        <img src={article.thumbnail} alt={article.title} />
      </div>
      <h3 className="blog-card-title">{article.title}</h3>
      <div className="blog-card-description">{article.description}</div>
      <div className="blog-card-footer">
        <span>By {article.author}</span>
        <span className="dot" />
        <span>{article.readTime}</span>
      </div>
    </div>
  );
};

export default BlogCard;
